import { render, staticRenderFns } from "./delivery_block.vue?vue&type=template&id=04142f00&scoped=true&"
import script from "./delivery_block.vue?vue&type=script&lang=js&"
export * from "./delivery_block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04142f00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04142f00')) {
      api.createRecord('04142f00', component.options)
    } else {
      api.reload('04142f00', component.options)
    }
    module.hot.accept("./delivery_block.vue?vue&type=template&id=04142f00&scoped=true&", function () {
      api.rerender('04142f00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/base/location_general_tab/delivery_block/delivery_block.vue"
export default component.exports